import { Suspense } from "react";

import { Outlet } from "react-router-dom";

import { RVLoading } from "../../atoms";

/**
 * Suspense-wrapped intermediary route shell for nested routes.
 *
 * Unlike `RVRoutingPage`, this component does not apply a full-page flex
 * layout wrapper. Use it inside nested route trees where a parent route has
 * already established page layout chrome.
 *
 * @example
 * ```tsx
 * <Route element={<RVNestedRoutingPage />}>
 *   <Route path="*" element={<NestedContent />} />
 * </Route>
 * ```
 */
export function RVNestedRoutingPage(): JSX.Element {
    return (
        <Suspense fallback={<RVLoading />}>
            <Outlet />
        </Suspense>
    );
}
